/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_Selfhost_QInputs */

const en_mk_hero_selfhost_q = /** @type {(inputs: Mk_Hero_Selfhost_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need it on your own servers?`)
};

const id_mk_hero_selfhost_q = /** @type {(inputs: Mk_Hero_Selfhost_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlu dipasang di server sendiri?`)
};

/**
* | output |
* | --- |
* | "Need it on your own servers?" |
*
* @param {Mk_Hero_Selfhost_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_selfhost_q = /** @type {((inputs?: Mk_Hero_Selfhost_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_Selfhost_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_selfhost_q(inputs)
	return en_mk_hero_selfhost_q(inputs)
});